var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orion_messaging-app",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M43.667,61A41.89,41.89,0,0,0,59.4,64.933V80.667L78.673,61.393c11.8-5.31,20.06-15.733,20.06-27.927C98.733,16.16,82.017,2,61.367,2S24,16.16,24,33.467c0,0,.2,2.557.393,3.933",
    transform: "translate(19.267 -2)",
    fill: "none",
    stroke: "#e9ae5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "layer2-2",
    "data-name": "layer2",
    cx: 1.986,
    cy: 1.986,
    r: 1.986,
    transform: "translate(78.432 29.639)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "layer2-3",
    "data-name": "layer2",
    cx: 1.986,
    cy: 1.986,
    r: 1.986,
    transform: "translate(62.547 29.639)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "layer2-4",
    "data-name": "layer2",
    cx: 1.986,
    cy: 1.986,
    r: 1.986,
    transform: "translate(94.317 29.639)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M71.62,87.457C55.493,84.7,57.067,80.573,57.067,77.82V72.9A27.337,27.337,0,0,0,64.933,53.04V39.863C64.933,25.507,54.51,20,45.267,20S25.6,25.507,25.6,39.863V53.04A27.14,27.14,0,0,0,33.663,72.9V77.82c0,2.753,1.377,6.883-14.553,9.637S2,98.667,2,102.6H88.533C88.533,98.667,85.977,90.013,71.62,87.457Z",
    transform: "translate(-2 15.4)",
    fill: "none",
    stroke: "#258eb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeeds);
export default __webpack_public_path__ + "static/media/icon-needs.53e47a3b15e612376d5f6e1561554159.svg";
export { ForwardRef as ReactComponent };